const DEFAULT_LOCALE = 'en-US';

const resolveLocale = (locale?: string): string => {
  const candidate = String(locale || '').trim();
  if (!candidate) {
    try {
      return window.localStorage.getItem('ninpo-locale') || DEFAULT_LOCALE;
    } catch {
      return DEFAULT_LOCALE;
    }
  }
  return candidate;
};

export const formatCurrency = (value: unknown, locale?: string): string => {
  const amount = Number(value);
  return new Intl.NumberFormat(resolveLocale(locale), {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number.isFinite(amount) ? amount : 0);
};

import { customerFacingStatus, type CustomerFacingOrderStatus } from './contracts';

const CUSTOMER_FACING_LABELS: Record<CustomerFacingOrderStatus, string> = {
  PENDING: 'Pending',
  CONFIRMED: 'Confirmed',
  SHOPPING: 'Shopping',
  AWAITING_DECISION: 'Action needed',
  OUT_FOR_DELIVERY: 'Out for delivery',
  ARRIVING: 'Arriving',
  DELIVERED: 'Delivered',
  REFUNDED: 'Refunded',
  CANCELED: 'Canceled',
  PAYMENT_ISSUE: 'Payment issue',
  CLOSED: 'Closed',
  DISPUTED: 'Disputed'
};

export const formatOrderStatus = (status: unknown): string => {
  const raw = String(status || '').trim();
  if (!raw) return 'Unknown';
  return raw
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
};

/**
 * Render the customer-facing label that storefronts should display for any
 * canonical or legacy status string. Backed by `customerFacingStatus()`.
 */
export const formatCustomerFacingOrderStatus = (status: unknown): string => {
  const bucket = customerFacingStatus(status);
  return CUSTOMER_FACING_LABELS[bucket] ?? 'Pending';
};

export const formatDateTime = (
  value: string | number | Date | null | undefined,
  locale?: string
): string => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(resolveLocale(locale));
};
